module.exports = __webpack_public_path__ + "img/soso.136c288a.png";